var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWrenchIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.793 54.948",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".wrench_icon_svg__a,.wrench_icon_svg__c,.wrench_icon_svg__d{fill:none}.wrench_icon_svg__a,.wrench_icon_svg__b,.wrench_icon_svg__c,.wrench_icon_svg__d{stroke:inherit;stroke-width:2px}.wrench_icon_svg__a,.wrench_icon_svg__b,.wrench_icon_svg__c{stroke-linecap:round;stroke-linejoin:round}.wrench_icon_svg__a,.wrench_icon_svg__b{fill-rule:evenodd}.wrench_icon_svg__b{fill:transparent}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "wrench_icon_svg__a",
    d: "M36.423 29.276h1.914a5.579 5.579 0 005.455-5.695H36.25M28.964 23.581h-6.29a4.072 4.072 0 00-3.734 2.65l-.046.125a6.314 6.314 0 01-3.364 3.5 5.7 5.7 0 01-2.175.431H11.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wrench_icon_svg__b",
    d: "M36.593 36.638h4.3a2.885 2.885 0 002.887-2.888 2.885 2.885 0 00-2.885-2.885h-9.991a3.017 3.017 0 01-.855-.125 2.991 2.991 0 01-1.967-1.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wrench_icon_svg__b",
    d: "M36.593 42.408h4.3a2.885 2.885 0 002.885-2.885 2.885 2.885 0 00-2.885-2.885h-4.3M35.069 48.178h5.84a2.885 2.885 0 002.885-2.885 2.885 2.885 0 00-2.885-2.885h-4.316M39.035 48.178a2.885 2.885 0 012.885 2.885 2.885 2.885 0 01-2.885 2.885h-9.991c-8.255 0-5.62-4.09-17.309-4.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wrench_icon_svg__c",
    d: "M1 26.428h10.416v26.813H1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wrench_icon_svg__d",
    d: "M34.601 29.874h-3.815a1.51 1.51 0 01-1.508-1.508V15.245a7.692 7.692 0 01-.104-13.428v5.764l3.518 3.015 3.516-3.015V1.55a7.568 7.568 0 014.459 6.954 7.7 7.7 0 01-4.557 7.025v12.833a1.51 1.51 0 01-1.509 1.512z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWrenchIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wrench_icon.7c203c4a4fc5b96e8b0d3bd5c1f75b08.svg";